export type ErrorClassification = 'AUTH_ERROR' | 'NETWORK_ERROR' | 'SERVER_ERROR' | 'CHUNK_ERROR' | 'TIMEOUT_ERROR' | 'PARSING_ERROR' | 'UNKNOWN_ERROR';

/**
 * Centralized utility to classify all errors into discrete application failure types.
 */
export const classifyError = (error: unknown): ErrorClassification => {
  if (!error || typeof error !== 'object') return 'UNKNOWN_ERROR';

  const err = error as Record<string, unknown>;

  // React ChunkLoadError
  if (err.name === 'ChunkLoadError' || (typeof err.message === 'string' && err.message.includes('Loading chunk'))) {
    return 'CHUNK_ERROR';
  }

  // RTK Query FetchBaseQueryError or serialized action error
  const status = err.status || err.name;
  const errorStr = (typeof err.error === 'string' ? err.error : '') || (typeof err.message === 'string' ? err.message : '');

  // Detect Timeout
  if (
    status === 'TIMEOUT_ERROR' || 
    errorStr.includes('TimeoutError')
  ) {
    return 'TIMEOUT_ERROR';
  }

  if (status !== undefined) {
    if (status === 401 || status === 403) {
      return 'AUTH_ERROR';
    }
    if (status === 'PARSING_ERROR') {
      return 'PARSING_ERROR';
    }
    // CORS preflight blocks or network disconnection typically result in 'FETCH_ERROR'
    if (status === 'FETCH_ERROR') {
      return 'NETWORK_ERROR';
    }
    if (typeof status === 'number' && status >= 500) {
      return 'SERVER_ERROR';
    }
  }

  // Fallback for native Fetch / Axios generic network errors
  if (err.name === 'TypeError' && err.message === 'Failed to fetch') {
    return 'NETWORK_ERROR';
  }

  return 'UNKNOWN_ERROR';
};
